import { Swiper, Pagination, Navigation } from 'swiper/js/swiper.esm';
import 'swiper/css/swiper.min.css';

const modules = [Pagination, Navigation];

export {
  Swiper,
  modules,
}
